import { formRecaptchaMixin } from "./form-recaptcha";
import { formStepsControlMixin } from "./form-steps-control";
import formFieldMixin from "./form-field";
import { mapActions, mapGetters } from "vuex";

export const formMixin = {
  mixins: [
    formStepsControlMixin,
    formRecaptchaMixin,
    formFieldMixin
  ],
  data: () => ({
    forms: [],
    steps: [],
    isValid: false,
    success: false,
    error: false,
    disabledForm: false,
    isPersonalData: false,
    errorPersonalData: false,
    dropzoneOptions: {
      url: 'callbackBecomeVendor',
      autoQueue: false,
      thumbnailWidth: 80,
      thumbnailHeight: 80,
      maxFiles: 12, // максимальное количество файлов
      maxFilesize: 10, // максимальный вес одного файла, MB
      addRemoveLinks: true,
      dictRemoveFile: '×',
      acceptedFiles: '.jpg,.jpeg,.png,.docx,.doc,.pdf,.txt,.tif,.svg',
      dictFileTooBig: 'Файл слишком большой. Максимальный размер файла: {{maxFilesize}} MB.',
      dictInvalidFileType: 'Вы не можете загружать файлы этого типа.',
      dictMaxFilesExceeded: 'Вы не можете больше загружать файлы.',
    },
  }),
  computed: {
    currentForm () {
      return this.forms[this.currentStep]
    },
  },
  methods: {
    ...mapActions('modal', {
      modalType_successOpen: 'modalType_successOpen',
      modalType_errorOpen: 'modalType_errorOpen',
      modalClose: 'modalClose'
    }),
    errorData() {
      this.$emit('error-data', { error: this.error })
    },
    openError(data) {
      if (this.white) {
        this.error = true;
        this.errorData();

        setTimeout(() => {
          this.error = false;
          this.errorData();
        }, 5000);

        return;
      }

      let text = this.$root.staticText.modal.errorText;
      if (data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0];
        if (data.errors[key][0]) {
          text = data.errors[key][0];
        }
      }
  
      this.modalType_errorOpen({
        text,
        title: this.$root.staticText.modal.errorTitleReg,
        btnEvent: this.$root.staticText.modal.successBtnEvent
      });
    },
    changePersonalData() {
      this.isPersonalData = !this.isPersonalData;
      this.errorPersonalData = !this.isPersonalData;
    },
    changeRadio(index, event) {
      this.forms[this.currentStep][index].value = event.target.value;
    },
    focusRegEvent(i) {
      this.forms[this.currentStep][i].error = false;
    },
    deleteChar(item) {
      item.value = item.value.replace(/\D/g, '');
    },
    keydownNumber(event) {
      if (
        // Разрешаем: backspace, delete, tab и escape
        event.keyCode === 46 || event.keyCode === 8 || event.keyCode === 9 || event.keyCode === 27 ||
        // Разрешаем: Ctrl+A
        (event.keyCode === 65 && (event.ctrlKey || event.metaKey)) ||
        // Разрешаем: Ctrl+V
        (event.keyCode === 86 && (event.ctrlKey || event.metaKey)) ||
        // Разрешаем: home, end, влево, вправо
        (event.keyCode >= 35 && event.keyCode <= 39)
      ) {

      } else {
        // Запрещаем все, кроме цифр на основной клавиатуре, а так же Num-клавиатуре
        if ((event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
          event.preventDefault();
        }
      }
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    validate () {
      let is_valid = true;

      for (const field of this.currentForm) {
        const result = this.validateField(field);

        if (result.valid) continue;

        is_valid = false;
      }

      // проверка галочки (если мы на последнем шаге)
      if (
        !this.$route.fullPath.includes('/lk') &&
        this.steps.length - 1 === this.currentStep &&
        !this.isPersonalData
      ) {
        this.errorPersonalData = true;
        is_valid = false;
      }

      this.isValid = is_valid;
    },
    clearFrom() {
      this.success = false;
      this.error = false;
      this.errorData();
      this.currentStep = 0;

      for (const step of this.forms) {
        for (const field of step) {
          field.error = false;
          field.valid = false;
          if (field.type === 'select') {
            field.value = [];
            if (field.typeField === 8 && this.$refs.selectCustom.length) {
              this.$refs.selectCustom.forEach(item => {
                item.clearSelect();
              });
            }

          } else if (field.type === 'checkbox') {
            field.list.forEach(item => item.checked = false);

          } else {
            field.value = '';
          }
        }
      }

      if (this.$refs.dropzone) this.$refs.dropzone[0].removeAllFiles(true);

      this.isPersonalData = false;
      this.errorPersonalData = false;
      document.querySelector('#personal-data-feedback' + this.formInfo.id).checked = false;
    },
    async sendForm () {
      this.disabledForm = true;
      const fd = new FormData();

      fd.append('recaptchaToken', this.recaptchaToken);

      if (this.formInfo.placeId) {
          fd.append('placeId', this.formInfo.placeId);
      }
      if (this.formInfo.id) {
          fd.append('id', this.formInfo.id);
      }
      if (this.formInfo.nameEntity) {
          fd.append('nameEntity', this.formInfo.nameEntity);
      }
      if (this.idEvent) {
          fd.append('entityId', this.idEvent);
      } else if (this.formInfo.entityId) {
          fd.append('entityId', this.formInfo.entityId);
      }

      
      for (const field of this.forms.flat(1)) {
        this.appendField(field, fd);
      }
      
      try {
        const res = await this.$http.post(this.action, fd);
        const data = await res.json();

        if (!data.success) throw data;

        if (this.white) {
          this.success = true;
          setTimeout(this.clearFrom, 5000);
          return;
        }

        this.modalType_successOpen({
          title: this.$root.staticText.modal.successTitleReg,
          text: this.$root.staticText.modal.successText,
          btnEvent: this.$root.staticText.modal.successBtnEvent,
        });
      } catch (data) {
        this.openError(data);
        this.clearFrom();
      } finally {
        this.disabledForm = false;
      }
    },
    submitRegEvent () {
      this.validate();

      if (!this.isValid) return;

      if (this.steps.length - 1 !== this.currentStep) {
        return this.forwardStep();
      }

      // если мы на последнем шаге, то отправляем форму
      if (process.env.NODE_ENV === 'development') {
        return this.sendForm();
      }

      if (!this.$refs?.recaptcha) {
        console.error('provide ref for recaptcha component');
        return;
      }

      this.executeRecaptcha();
    }
  },
  created () {
    if (process.env.NODE_ENV === 'development') console.debug("created() call from mixins/form.js");

    this.formInfo.fields.forEach(field => {
      this.steps.push({
        title: field.content.title,
        description: field.content.description,
      });

      field.children.forEach(item => {
        item.content.value = item.content.defaultValue ? item.content.defaultValue : '';
        item.content.error = false;
        item.content.valid = false;

        this.setupField(item.content)
      });

      // Object.assign нужен для реактивности
      this.forms.push(field.children.map(item => Object.assign({}, item.content)));

  });
  }
}


// WEBPACK FOOTER //
// ./src/templates/components/mixins/form-steps.js